import { Component, NgModule, OnInit, Input, Output, ViewContainerRef } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { MdDialog, MdDialogConfig } from '@angular/material';

import { ConfirmationService } from 'primeng/primeng';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { ConstantsService } from 'app/services/constants-service';
import { AddServiceComponent } from 'app/admin/services/addservice/add-service.component';

import { ServiceService } from './service.service';
import { ClientServicesService } from 'app/entities/details/services/client-services.service';

import { Service } from 'app/admin/services/service.model';
import { ClientService, ServiceValue } from 'app/entities/details/services/client-service.model';
import { ServiceType } from 'app/entities/details/services/client-service.model';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';

@Component({
    selector: 'admin-service',
    providers: [ServiceService, ConfirmationService],
    templateUrl: './service.component.html',
    styleUrls: ['./service.component.css']
})

/**
 * Archival component to for entity deletion.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
 */
export class ServiceComponent implements OnInit {
    dialogRef: MdDialogRef<any>;
    serviceCategoryList: Array<ServiceType> = [];
    categoryServicesList: Array<ClientService>;
    servicesMap: Map<ServiceType, Array<ClientService>>;
    currentlySelectedCategory: any;
    categoryLoaded = false;
    servicesLoaded = false;

    selectedIndex: 0;
    subscription: any;
    entityName: string;
    archivalEntityListItems: any[] = [];
    archivalEntitySearchURI = ConstantsService.ARCHIVAL_ENTITY_SEARCH;
    archivalEntitySearchPlaceHolder = MessageService.ARCHIVAL_ENTITY_SEARCH_PLACEHOLDER;
    config: MdDialogConfig = {
        disableClose: true,
        width: '',
        height: '',
        position: {
            top: '',
            bottom: '',
            left: '',
            right: ''
        }
    };

    constructor(
        private serviceService: ServiceService,
        private clientServicesService: ClientServicesService,
        private warmUpService: WarmUpService,
        private dialog: MdDialog,
        private snackBarService: SnackBarService,
        private viewContainerRef: ViewContainerRef,
        private trackingService: TrackingService,
        private confirmationService: ConfirmationService, ) { }

    ngOnInit(): void {
        this.loadServiceCategories();
    }

    loadServiceCategories() {
        this.serviceCategoryList.push(ServiceType.TRUSTEE);
        this.serviceCategoryList.push(ServiceType.DOMICILE_SEC);
        this.serviceCategoryList.push(ServiceType.DOMICILE_PLUS);
        this.serviceCategoryList.push(ServiceType.MGT_SVC);
        this.serviceCategoryList.push(ServiceType.MEDIATE_SELLING);
        this.serviceCategoryList.push(ServiceType.PARTNER);
        this.serviceCategoryList.push(ServiceType.SUPPLY_CONDUIT_COMPANY);
        this.serviceCategoryList.push(ServiceType.OTHER);

        this.selectServiceCategoryRow(this.serviceCategoryList[0]);
        this.categoryLoaded = true;
    }

    selectServiceCategoryRow(selectedCategoryName) {
        this.currentlySelectedCategory = selectedCategoryName;
        this.loadCategoryServices();
    }

    loadCategoryServices() {
        let servicesList = [];
        this.clientServicesService.listClientServices().subscribe(
            response => {
                this.servicesMap = response.arrResult;
                this.categoryServicesList = this.getCategoryServicesList();
                this.servicesLoaded = true;
            },
            err => {
                this.callSnackBarService(err, '', MessageService.GENERIC_SEARCH_FAILURE);
            }
        );
    }

    getCategoryServicesList() {
        if (!this.servicesMap) {
            return [];
        }
        // $todo: Check whether there is a better way to traverse the map.
        switch (this.currentlySelectedCategory) {
            case 'Act as trustee': return this.servicesMap['TRUSTEE'];
            case 'Domicile sec': return this.servicesMap['DOMICILE_SEC'];
            case 'Domicile plus': return this.servicesMap['DOMICILE_PLUS'];
            case 'Management Services': return this.servicesMap['MGT_SVC'];
            case 'Mediate in selling the company': return this.servicesMap['MEDIATE_SELLING'];
            case 'Partner': return this.servicesMap['PARTNER'];
            case 'Supplying a coduit company': return this.servicesMap['SUPPLY_CONDUIT_COMPANY'];
            case 'Other': return this.servicesMap['OTHER'];
        }
    }

    openAddServicePopup() {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(AddServiceComponent, config);
        this.dialogRef.componentInstance.serviceCategotyType = this.currentlySelectedCategory;
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            this.loadCategoryServices();
        });
    }

    openServiceDeleteFailurePopUp() {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(AddServiceComponent, config);
        this.dialogRef.componentInstance.serviceCategotyType = this.currentlySelectedCategory;
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            this.loadCategoryServices();
        });
    }

    deleteService(value: ClientService): void {
        if (confirm(MessageService.DELETE_ADMIN_SERVICE_ALERT)) {
            this.serviceService.deleteAdminService(value.id)
                .subscribe(response => {
                    if (response.arrResult && response.arrResult.length > 0) {
                        let strImpactedClients = response.arrResult.join(", ")
                        let impactedClientMessage = "This service is in use and cannot be deleted. "
                        impactedClientMessage += "Impacted Client(s): " + strImpactedClients;
                        this.confirmationService.confirm({
                            message: impactedClientMessage,
                            reject: () => { }
                        });
                    }
                    else {
                        this.loadCategoryServices();
                        this.trackingService
                            .emitEvent(
                            TrackingConstants.ADMIN_SERVICE_MANAGEMENT,
                            TrackingConstants.DELETE_ADMIN_SERVICE,
                            TrackingConstants.SUCCESS, 1);
                        this.callSnackBarService(response,
                            MessageService.DELETE_ADMIN_SERVICE_SUCCESS,
                            MessageService.ACTION_FAILURE
                        );
                    }
                },
                err => {
                    this.trackingService
                        .emitEvent(
                        TrackingConstants.ADMIN_SERVICE_MANAGEMENT,
                        TrackingConstants.DELETE_ADMIN_SERVICE,
                        TrackingConstants.FAILURE, 0);
                    this.callSnackBarService(err,
                        MessageService.DELETE_ADMIN_SERVICE_SUCCESS,
                        MessageService.ACTION_FAILURE
                    );
                });
        }
    }

    // Method to display success / failure message.
    callSnackBarService(response: any, successMsg: string, failureMsg: string) {
        this.snackBarService.showStatus(response, successMsg, failureMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/services/service.component.ts